<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <q-form ref="editForm">
          <c-card title="기본정보" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn
                  v-if="editable"
                  label="저장"
                  icon="save" />
                <c-btn
                  v-if="editable"
                  label="삭제"
                  icon="remove" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
                <div class="col-4">
                  <c-text
                    :editable="editable"
                    label="방지시설명"
                    name="col1"
                    v-model="data.col1">
                  </c-text>
                </div>
                <div class="col-4">
                  <c-text
                    :editable="editable"
                    label="방지시설 관리번호"
                    name="col2"
                    v-model="data.col2">
                  </c-text>
                </div>
                <div class="col-4">
                  <c-plant :required="true" type="edit" name="col0" v-model="data.col0" />
                </div>
                <div class="col-4">
                  <c-dept type="edit" label="관리부서" name="col3" v-model="data.col3" />
                </div>
                <div class="col-4">
                  <c-radio
                    :editable="editable"
                    :comboItems="useFlagItems"
                    label="사용여부"
                    name="useFlag"
                    v-model="data.useFlag">
                  </c-radio>
                </div>
            </template>
          </c-card>
        </q-form>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-card title="시설정보" class="cardClassDetailForm">
          <template slot="card-detail">
              <div class="col-4">
                <c-text
                  :editable="editable"
                  label="처리용량"
                  suffix="㎡/min"
                  name="col5"
                  v-model="data.col5">
                </c-text>
              </div>
              <div class="col-4">
                <c-text
                  :editable="editable"
                  label="설계(허가증)용량"
                  suffix="㎡/분"
                  name="col6"
                  v-model="data.col6">
                </c-text>
              </div>
              <div class="col-4">
                <c-text
                  :editable="editable"
                  label="허가증 기준유량"
                  suffix="%"
                  name="col7"
                  v-model="data.col7">
                </c-text>
              </div>
          </template>
        </c-card>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <c-table
          ref="grid"
          title="보수(고장이력) 목록"
          tableId="grid"
          :columns="grid.columns"
          :data="grid.data"
          :usePaging="false"
          :hideBottom="true"
          :columnSetting="false"
          :filtering="false"
          gridHeight="400px"
        >
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="저장" v-if="editable" icon="save" />
              <c-btn label="추가" v-if="editable" icon="add" />
              <c-btn label="삭제" v-if="editable" icon="remove" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <c-table
          ref="grid2"
          title="부품 목록"
          tableId="grid2"
          :columns="grid2.columns"
          :data="grid2.data"
          :usePaging="false"
          :hideBottom="true"
          :columnSetting="false"
          :filtering="false"
          gridHeight="400px"
        >
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="저장" v-if="editable" icon="save" />
              <c-btn label="추가" v-if="editable" icon="add" />
              <c-btn label="삭제" v-if="editable" icon="remove" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
  </div>
</template>
<script>
// import selectConfig from '@/js/selectConfig';
// import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'water-master03-detail',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          title: '',
          psiDocumentId: '',
          documentClassCd: '',
        }
      },
    },
    contentHeight: null,
  },
  data() {
    return {
      data: {
        col0: '',
        col1: 'G1A (저장~혼합)',
        col2: 'G1A-001',
        col5: '300',
        col6: '181.61',
        col7: '61',
        useFlag: 'Y',
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      grid: {
        columns: [
          {
            name: 'col0',
            field: 'col0',
            label: '고장일',
            align: 'center',
            type: 'date',
            style: 'width: 130px',
            sortable: false,
          },
          {
            name: 'col1',
            field: 'col1',
            label: '보수시작일',
            align: 'center',
            type: 'date',
            style: 'width: 130px',
            sortable: false,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '보수종료일',
            align: 'center',
            type: 'date',
            style: 'width: 130px',
            sortable: false,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '보수자',
            align: 'center',
            type: 'text',
            style: 'width: 100px',
            sortable: false,
          },
          {
            name: 'col4',
            field: 'col4',
            label: '보수명세',
            align: 'left',
            type: 'text',
            sortable: false,
          },
        ],
        data: [],
      },
      grid2: {
        columns: [
          {
            name: 'col0',
            field: 'col0',
            label: '부품명',
            align: 'center',
            type: 'text',
            style: 'width: 200px',
            sortable: false,
          },
          {
            name: 'col1',
            field: 'col1',
            label: '교체주기',
            align: 'center',
            type: 'text',
            style: 'width: 100px',
            sortable: false,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '최근교체일',
            align: 'center',
            style: 'width: 130px',
            sortable: false,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '다음교체예정일',
            align: 'center',
            style: 'width: 130px',
            sortable: false,
          },
          {
            name: 'col4',
            field: 'col4',
            label: '부품 상세',
            align: 'left',
            type: 'text',
            sortable: false,
          },
        ],
        data: [],
      },
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 220);
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.getData();
    },
    getData() {
      this.grid.data = [
        {
          col0: '2021-01-02',
          col1: '2021-01-04',
          col2: '2021-01-06',
          col3: '관리자',
          col4: '방지시설 보수 내역',
        },
      ]
      this.grid2.data = [
        {
          col0: '부품2-124A',
          col1: '1년',
          col2: '2021-05-01',
          col3: '2022-05-02',
          col4: 'A형 부품',
        },
      ]
    },
  }
};
</script>